const body = document.querySelector('body');
const lockPadding = document.querySelectorAll('.lock-padding');

let unlock = true;

const timeout = 800;
const timeToLoadNodes = 200;

const bodyUnLock = () => {
  setTimeout(() => {
    if (lockPadding.length > 0) {
      for (let index = 0; index < lockPadding.length; index++) {
        const el = lockPadding[index];
        el.style.paddingRight = '0px';
      }
    }
    body.style.paddingRight = '0px';
    body.classList.remove('lock-popup');
  }, timeout);

  unlock = false;
  setTimeout(() => {
    unlock = true;
  }, timeout);
};

const popupClose = (popup, doUnlock = true) => {
  if (!unlock) {
    return;
  }

  popup.classList.remove('open');

  const ajax = popup.dataset.ajax;
  if (ajax) {
    setTimeout(() => {
      popup.innerHTML = '';
    }, timeout);
  }

  if (doUnlock) {
    bodyUnLock();
  }
};

window.popupClose = popupClose;

window.popupsInit = () => {
  const moduleName = 'popups';

  [...document.querySelectorAll('.popup')].forEach((self) => {
    if (self.dataset[`${moduleName}Init`]) {
      return;
    }
    self.dataset[`${moduleName}Init`] = true;

    const popup = self;

    popup.addEventListener('mousedown', (event) => {
      const element = event.target.closest('.close-popup');
      const isBackground = event.target.classList.contains('popup__body');

      if (isBackground || element) {
        event.preventDefault();
        event.stopPropagation();

        popupClose(popup);
      }
    });
  });

  [...document.querySelectorAll('.popup-link')].forEach((self) => {
    if (self.dataset[`${moduleName}Init`]) return;

    self.dataset[`${moduleName}Init`] = true;

    self.addEventListener('click', (event) => {
      const popupName = self.getAttribute('href').replace('#', '');

      const currentPopup = document.querySelector(`.popup_${popupName}`);
      if (self.getAttribute('data-video')) {
        const container = currentPopup.querySelector('.video-container');
        container.innerHTML = `<iframe width="auto" height="315" src="${self.getAttribute('data-video')}"
        frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
      }

      window.popupOpen(currentPopup, false);

      event.preventDefault();
    });
  });
};

window.popupsInit();

const slideUp = (target, duration = 500) => {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = `${duration}ms`;
  target.style.boxSizing = 'border-box';
  target.style.height = 'auto';
  target.style.overflow = 'hidden';
  target.classList.add('_opened');
  window.setTimeout(() => {
    target.style.display = 'block';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

const bodyLock = () => {
  const lockPaddingValue = `${window.innerWidth - document.querySelector('.wrapper').offsetWidth}px`;

  if (lockPadding.length > 0) {
    for (let index = 0; index < lockPadding.length; index++) {
      const el = lockPadding[index];
      el.style.paddingRight = lockPaddingValue;
    }
  }
  body.style.paddingRight = lockPaddingValue;
  body.classList.add('lock-popup');

  unlock = false;
  setTimeout(() => {
    unlock = true;
  }, timeout);
};

const initAjaxForms = (popup) => {
  const statusFormSuccess = (selector, response) => {
    const formattedResponse = response.trim();
    const isScript = formattedResponse.startsWith('<script') && formattedResponse.endsWith('</script>');
    const rawScript = formattedResponse.slice(formattedResponse.indexOf('>') + 1, formattedResponse.length - 9);
    if (isScript) {
      // eslint-disable-next-line
      eval(rawScript);
    } else {
      const elem = document.querySelector(selector);
      if (elem) elem.innerHTML = response;
      if (response.includes('<script')) {
        const script = response.slice(response.indexOf('<script>') + 1, response.indexOf('</script>'));
        // eslint-disable-next-line
        eval(script);
      }
    }
  };

  const statusFormError = (alert, error) => {
    alert.innerHTML = error.innerHTML;
  };

  window.initForm();
  if (!popup) {
    return;
  }
  const formSelector = `#${popup.id}`;
  const formElem = document.querySelector(formSelector);

  if (!formElem.classList.contains('_init')) {
    formElem.addEventListener('submit', async (e) => {
      e.preventDefault();

      const alerts = document.querySelectorAll('.error_request');
      const inputs = formElem.querySelectorAll('input');

      let hasErrors = false;
      inputs.forEach((el) => {
        if (el.classList.contains('_error')) {
          hasErrors = true;
        }
      });
      if (hasErrors) return;

      const form = e.target;
      const data = new FormData(form);

      const isRecaptchaDisabled = process.env.RECAPTCHA_NO_CHECK || false;
      // eslint-disable-next-line
    if (grecaptcha && !isRecaptchaDisabled) {
      // eslint-disable-next-line
      const token = await grecaptcha.execute(process.env.RECAPTCHA_TOKEN);
        data.append('g-recaptcha-response', token);
      }

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: data,
        });
        const result = await response.text();
        const rawHtml = new DOMParser().parseFromString(result, 'text/html');
        if (response.status !== 200 && formSelector === '#auth') {
          window.clearCookie();
        }
        if (rawHtml) {
          const errorText = rawHtml.querySelector('.errorText');
          if (errorText) {
            alerts.forEach((el) => {
              statusFormError(el, errorText);
              slideUp(el);
            });
          } else {
            statusFormSuccess(formSelector, result);
            // eslint-disable-next-line
          if (popup.id === 'forgot-pass') popupOpenUniversalForm('', 'Информация отправлена на указанный e-mail');
          }
        }
      } catch (err) {
      // eslint-disable-next-line
      console.error(err);
      }
    });

    formElem.classList.add('_init');
  }
};

const initIndividualScripts = (popupId) => {
  if (!popupId) return;

  const popupScriptsData = {
    'import-popup': [
      window.bindImportEvents,
      window.initImportPopupDropzone,
    ],
  };

  if (popupScriptsData[popupId]) {
    popupScriptsData[popupId].forEach((func) => {
      if (func && typeof func === 'function') func();
    });
  }
};

const initScriptsForPopup = (popup) => {
  initIndividualScripts(popup.id);
  window.popupsInit();
  window.initForm();
  window.customSelect();
  window.phoneMaskInit();
  initAjaxForms(popup);
  window.initImportFileHandler();
};

const popupOpen = async (popup, noCloseActivePopup = true) => {
  if (!(popup)) {
    return;
  }

  const popupActive = document.querySelector('.popup.open');

  if (!noCloseActivePopup && popupActive) {
    popupClose(popupActive, false);
  } else {
    bodyLock();
  }

  const { ajax, url } = popup.dataset;
  if (ajax && url) {
    try {
      const res = await fetch(url);
      const content = await res.text();

      const container = document.querySelector(`#${popup.id}`);
      container.innerHTML = content;
      setTimeout(() => {
        popup.classList.add('open');
        initScriptsForPopup(popup);
      }, timeToLoadNodes);
    } catch (error) {
      // eslint-disable-next-line
      console.error(error);
    }
  } else {
    popup.classList.add('open');
  }
};

window.popupOpen = popupOpen;

const popupOpenUniversalForm = (title = '', text = '', noCloseActivePopup = false) => {
  const modal = document.getElementById('universal-popup');
  const titleModal = modal ? modal.querySelector('.universal-message__title') : null;
  const textModal = modal ? modal.querySelector('.universal-message__text') : null;

  titleModal.innerHTML = title;
  if (titleModal) {
    titleModal.innerHTML = title;
  }
  if (textModal) {
    textModal.innerHTML = text;
  }

  if (modal) {
    popupOpen(modal, noCloseActivePopup);
  }
};

window.popupOpenUniversalForm = popupOpenUniversalForm;

document.addEventListener('keydown', (e) => {
  if (e.which === 27) {
    const popupActive = document.querySelector('.popup.open');
    popupClose(popupActive);
  }
});

(() => {
  // проверяем поддержку
  if (!Element.prototype.closest) {
    // реализуем
    Element.prototype.closest = (css) => {
      let node = this;
      while (node) {
        if (node.matches(css)) {
          return node;
        }
        node = node.parentElement;
      }
      return null;
    };
  }
})();

const popupAuthOpen = () => {
  const auth = document.querySelector('.popup_authorization');

  if (auth) {
    popupOpen(auth);
  }
};

const popupNotAvailable = () => {
  const notAvailable = document.querySelector('.popup_not-available');

  if (notAvailable) {
    popupOpen(notAvailable);
  }
};

const popupForgotPass = () => {
  const forgotPass = document.querySelector('.popup_forgot-pass');

  if (forgotPass) {
    popupOpen(forgotPass);
  }
};

const popupImport = () => {
  const importPopup = document.querySelector('.popup_import');

  if (importPopup) {
    popupOpen(importPopup);
  }
};
window.popupImport = popupImport;

const copyOrder = (id) => {
  window.location.href = `/orders/?COPY_ORDER=Y&ID=${id}`;
};

const popupCleanCart = () => {
  const cleanCart = document.querySelector('.popup_clean-cart');
  const cleanCartBtns = document.querySelectorAll('.popup_clean-cart ._btn');

  const urlString = window.location.href;
  const url = new URL(urlString);
  const id = url.searchParams.get('id');

  if (cleanCart) {
    popupOpen(cleanCart);

    if (id) {
      cleanCartBtns.forEach((button) => {
        button.addEventListener('click', () => {
          copyOrder(id);
        });
      });
    }
  } else if (id) {
    copyOrder(id);
  }
};

const popupRegOpen = () => {
  const reg = document.querySelector('.popup_registration');

  if (reg) {
    popupOpen(reg);
  }
};

const popupPassChange = () => {
  const passChange = document.querySelector('.popup_pass-change');

  if (passChange) {
    popupOpen(passChange);
  }
};

const popupWarningMessage = async () => {
  if (!await window.isLoadPopup('cookie-popup')) {
    return;
  }
  const warningMessage = document.querySelector('.popup_warning-message');

  if (warningMessage) {
    popupOpen(warningMessage);
  }
};

(() => {
  // проверяем поддержку
  if (!Element.prototype.matches) {
    // определяем свойство
    Element.prototype.matches = Element.prototype.matchesSelector
            || Element.prototype.webkitMatchesSelector
            || Element.prototype.mozMatchesSelector
            || Element.prototype.msMatchesSelector;
  }
})();

const getPopup = async (id) => {
  const url = `/local/ajax/popups/${id}.php`;
  const response = await fetch(url);
  if (response.ok) {
    const result = await response.text();
    return result;
  }
  return false;
};

window.isLoadPopup = async (id) => {
  if (document.querySelector(`#${id}`)) {
    return true;
  }
  const html = await getPopup(id);
  if (html) {
    const wrapper = document.querySelector('#ajax-modal-wrapper');
    wrapper.innerHTML = html;
    window.popupsInit();
    return true;
  }
  return false;
};

export {
  popupWarningMessage,
  popupPassChange,
  popupRegOpen,
  popupCleanCart,
  popupNotAvailable,
  popupForgotPass,
  popupAuthOpen,
};

const clearCookieAndSession = () => {
  localStorage.clear();
  sessionStorage.clear();
  popupOpenUniversalForm('Ошибка', 'Что-то пошло не так. Сессия будет сброшена');
  fetch('/local/ajax/clearCookieAndSession.php').then((r) => {
    r.text();
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  });
};
window.clearCookie = clearCookieAndSession;
